module.exports = __webpack_public_path__ + "static/media/3 10 Tulleord Blastell er feil.975b0965.mp3";